export default __webpack_public_path__ + "../staticImages/taste--PASST_ZU.svg";